import addItem from "./addItem.component";

const addItemModule = angular
  .module("app.components.addItem", [])
  .component("addItem", addItem);

export default addItemModule;



// WEBPACK FOOTER //
// ./src/components/addItem/addItem.module.js